module.exports = __webpack_public_path__ + "img/5.16d1de3a.png";